import axios from "axios";

import * as actionTypes from "./actionTypes";
import * as urls from "../../config/actionUrl";

/*function addDays(date, days) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
}*/

export const authStart = () => {
    return {
        type: actionTypes.AUTH_START
    };
};

export const authSuccess = (token, userId) => {
    return {
        type: actionTypes.AUTH_SUCCESS,
        idToken: token,
        userId: userId
    };
};



export const authFail = (error) => {
    return {
        type: actionTypes.AUTH_FAIL,
        error: error
    };
};

export const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("expirationDate");
    localStorage.removeItem("userId");
    localStorage.removeItem("username");
    return {
        type: actionTypes.AUTH_LOGOUT
    };
};

export const checkAuthTimeout = (expirationTime) => {
    return dispatch => {
        setTimeout(() => {
            dispatch(logout());
        }, expirationTime * 10000000000);
    };
};

export const auth = (email, password, rememberMe) => {
    return dispatch => {
        dispatch(authStart());
        axios.post(urls.VIOME_AUTH_URL,{email,password,rememberMe},{
            headers: { "content-type": "application/json" },
            referrerPolicy: "no-referrer-when-downgrade",
            mode: "cors",
            withCredentials: true
        })
            .then(response => {
                const responseData = response.data;
                const responseHeaders = response.headers;

                let expirationDate = new Date();
                expirationDate.setMonth(expirationDate.getMonth() + 3);

                localStorage.setItem("token", responseHeaders.token);
                localStorage.setItem("expirationDate", expirationDate);
                localStorage.setItem("userId", responseData.userID);
                localStorage.setItem("username",email);

                //Dispatch Actions
                dispatch(authSuccess(responseHeaders.token, responseData.userID));
                //dispatch(checkAuthTimeout(expirationDate));
            })
            .catch(err => {
                dispatch(authFail(err.response.data));
            }); 
    };
};

export const setAuthRedirectPath = (path) => {
    return {
        type: actionTypes.SET_AUTH_REDIRECT_PATH,
        path: path
    };
};

export const authCheckState = () => {
    return dispatch => {
        const token = localStorage.getItem("token");
        if (!token) {
            dispatch(logout());
        } else {
            const expirationDate = new Date(localStorage.getItem("expirationDate"));
            const loginDate = new Date();
            if (loginDate >= expirationDate) {
                dispatch(logout());
            } else {
                const userId = localStorage.getItem("userId");
                dispatch(authSuccess(token, userId));
                //dispatch(checkAuthTimeout((expirationDate.getTime() - new Date().getTime()) / 1000));
            }
        }
    };
};
